var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g4, _g5, _path34, _g6, _path35, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH2ClosedImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,64V25h2v-7h2v-4h2v-2h2v-2h4V8h4V6h4V4h2V2h2V0h6v2h2v2h2v2h4v2h4v2h4v2h2v2h2v4h2v7h2v39H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,64V25h2v-7h2v-4h2v-2h2v-2h4V8h4V6h4V4h2V2h2V0h6v2h2v2h2v2h4v2h4v2h4v2h2v2h2v4h2v7h2v39H5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#141414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 14h-4v2h4v-2zm-12-2v2h6v-2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 10h-2v2h2v-2zm12 19v4h2v-4h-2zm2 6h-2v4h2v-4zm0 18h-2v2h2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 59h-2v2h2v-2zm0-34h-2v2h2v-2zm-2-3h2v-2h-2v2zm2 33v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 45v2h4v-2h-4zm2 16v3h2v-3h-2zm-2-43h-4v2h4v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-4v2h4v-2zm6 23v2h4v-2h-4zM23 14v2h4v-2h-4zm6-4h-2v2h2v-2zm-14 8v2h4v-2h-4zm-2 11v4h2v-4h-2zm0 6v4h2v-4h-2zm0 18v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 45v2h4v-2h-4zm2 14v2h2v-2h-2zm0-34v2h2v-2h-2zm-2 30v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 61v3h2v-3h-2zM9 39v2h4v-2H9zm4-19v2h2v-2h-2zm6-4v2h4v-2h-4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1e1e1e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,12h2v-2h-2V8h-6v4h-2v2h8V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 6h-2V4h-2V2h-6v2h-2v2h-2v2h2v2h2v2h6v-2h2V8h2V6zm-4 2v1h-1v1h-1v1h-2v-1h-1V9h-1V8h-1V6h1V5h1V4h1V3h2v1h1v1h1v1h1v2h-1zm16 10v-2h2v-2h-2v-2h-4v2h-2v4h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 22h-2v3h6v-7h-4v4zm0 13v4h6v-4h-6zm0 8v-2h-2v4h4v2h2v-2h2v-2h-6zm4 10v-2h-2v-2h-4v4h2v2h2v2h2v-2h2v-2h-2zm-4 6v2h2v3h4v-5h-6zm0-32v6h4v-2h2v-4h-6zM19 8v2h-2v2h2v2h8v-2h-2V8h-6zm-8 41v2H9v2H7v2h2v2h2v-2h2v-2h2v-4h-4zm2-8v2H7v2h2v2h2v-2h4v-4h-2zM7 59v5h4v-3h2v-2H7zm2-41v7h6v-3h-2v-4H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14v-2h-4v2h-2v2h2v2h6v-4h-2zM9 31v2h4v-6H7v4h2zm4 8v-4H7v4h6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 33v2h2v-2h-2zm0 18v2h2v-2h-2zm0 6v2h2v-2h-2zm0-16v2h2v-2h-2zm0-16v2h2v-2h-2zm-4 24v2h2v-2h-2zm-6-11v2h2v-2h-2zm-2 16v-4h-2v6h4v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 36h-2v2h2v-2zm-2 10v-2h-2v4h4v-2h-2zm0 16v-2h-2v4h4v-2h-2zm2-30v-2h-2v-2h-2v4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 34h-2v2h2v-2zm0 8v-2h-2v2h2zm2-22v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22v1h-2v2h4v-3h-2zm16 11v2h2v-2h-2zm0 18v2h2v-2h-2zm0 6v2h2v-2h-2zm0-16v2h2v-2h-2zm0-16v2h2v-2h-2zm4 24v2h2v-2h-2zm6-11v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 36v2h2v-2h-2zm2 24v2h-2v2h4v-4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 40v2h2v-2h-2zm0-6v2h2v-2h-2zm0 10v2h-2v2h4v-4h-2zm0-16v2h-2v2h4v-4h-2zm0 22v4h-2v2h4v-6h-2zM29 16v2h2v2h2v-2h2v-2h-6zm16 4h-2v2h2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,23v-1h-2v3h4v-2H47z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35,12v2h2v-2H35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12V8h-2v4h2zm-6-3h1v1h-1V9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34,8h1v1h-1V8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 8h1V6h-1v2zm6 0V6h-2v2h2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34,5h1v1h-1V5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 4h1v1h-1V4zm16 57v3h2v-3h-2zm2-22h-2v-3h-2v2h-2v2h-6v1h-4v2h4v-1h6v2h4v-2h-2v-2h2v1h2v-2zm-2-12v-2h-2v3h2v1h2v-2h-2zm-2-7v2h2v-2h-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h2v-2h-2v2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-4h-2v2h-2v2h4zm-10-2v-2h-4v2h4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-2h-2v2h2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12v-2h-2v2h2zm0 21v-1h-4v2h4v1h6v-2h-6zm2 24v-2h-2v1h-4v2h2v2h2v-1h6v-2h-4zm0-16v2h4v-2h-4zm0-16v2h4v-2h-4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25h2v-2h-2v2zm2 4v2h-2v2h4v-4h-2zm-2 26v2h4v-2h-4zm0-10v2h-6v1h-4v2h4v-1h6v2h2v2h2v-4h-2v-2h2v-2h-4zm2 16v3h2v-3h-2zm-2-22v2h4v-2h-4zM29 12h-2v2h2v-2zm2-2v1h2v-1h-2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27 8h-2v4h2V8zm3 1h1v1h-1V9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29,8h1v1h-1V8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6h-1v2h1V6zm-4 0h-2v2h2V6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5h1v1h-1V5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4h1v1h-1V4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33 4V3h-2v1h2zM15 22h2v-2h-2v2zm-2 7h2v-1h2v-3h-2v2h-2v2zm0 32v3h2v-3h-2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41v2h4v-2H9zm4-21h2v-2h-2v2zm6-4h4v-2h-4v2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14h2v-2h-2v2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12v-2h-2v2h2zM9 27h4v-2H9v2zm4-9v-2h-2v-2H9v4h4zM9 31H7v-2H5v4h4v-2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55H5v2h4v-2zm0-16H5v2h4v-2zm0-14v-2H7v2h2zM5 61v3h2v-3H5zm20-28v-1h-2v2h2v1h4v-2h-4zm0 24v2h4v-2h-4zm0-16v-1h-6v-2h-2v-2h-2v3h-2v2h2v-1h2v2h-2v2h4v-2h6v1h4v-2h-4zm-2 19v2h2v-2h-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28v-1h4v-2h-6v3h2zm-2 2h-4v2h4v-2zm0 16h-4v2h4v-2zm-4 16v2h4v-2h-4zm6-6v-2h-6v2h6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19 56h-4v-1h-2v2H9v2h6v1h2v-2h2v-2zm-4-24v1H9v2h6v-1h4v-2h-4zm0 16v-1H9v-2H5v2h2v2H5v4h2v-2h2v-2h6v1h4v-2h-4zm16 12v2h2v-2h-2zm0-32h2v-4h-2v4zm-2-8h2v-2h-2v2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16v-2h-2v2h2zm0 6h-2v2h2v-2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18h6v-2h-6v2zm-2 4h4v-2h-4v2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18h-2v2h2v-2zm-2 5v2h2v-2h-2zm16 8h-2v-1h-2v1h-2v2h2v1h2v-1h2v-2zm0 24h-2v-1h-2v1h-2v2h2v-1h2v1h2v-2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35 39h-2v1h-2v-1h-2v2h2v1h2v-1h2v-2zm4 18h-4v2h4v-2zm2 3h-2v2h2v-2zm-2-28v1h-4v2h4v-1h2v-2h-2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v-3h-6v2h4v1h2zm-2 20v-1h-4v-2h-2v3h-2v-3h-2v2h-4v1h-2v2h2v-1h4v2h2v-1h2v1h2v-2h4v1h2v-2h-2zm6 6h-6v2h6v-2zm0-24h-4v2h4v-2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45 46h-4v2h4v-2zm-4 16v2h4v-2h-4zm-6-44h6v-2h-6v2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18v2h2v-2h-2zm0-4v2h2v-2h-2zm2 10v-2h-2v2h2zm4-4v2h4v-2h-4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45 18h-2v2h2v-2zm-2 5v2h2v-2h-2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 55v2h2v-2h-2zm0-10v2h2v-2h-2zm0 16v3h2v-3h-2zm-2-22v2h4v-2h-4zm-2 17v4h2v-4h-2zm0-20h2v-2h-2v2zm-2 6v2h4v-2h-4zm2-12h2v-2h-2v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 50v4h2v-4h-2zm0 12v2h2v-2h-2zm0-28v-2h-2v2h2zm0-6v-3h2v-2h-4v5h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-4v2h4v-2zm8 8v4h2v-4h-2zm0-22v2h2v-2h-2zm0 8v2h2v-2h-2zm0-14v2h2v-2h-2zm0 22v4h2v-4h-2zm0 12v2h2v-2h-2zm-2-44h-2v2h2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 20h-2v2h2v-2zm-4 3v2h2v-2h-2zm-4-3v-2h-2v2h2zm12 35v2h2v-2h-2zm0-10v2h2v-2h-2zm0 16v3h2v-3h-2zm4-22h-4v2h4v-2zm0 17v4h2v-4h-2zm2-20v-2h-2v2h2zm0-6v-2h-2v2h2zm-2 20v4h2v-4h-2zm0 12v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 34v-2h-2v2h2zm-4 8v2h4v-2h-4zm4-14v-5h-4v2h2v3h2zm-2 20v2h4v-2h-4zm-4-28v-2h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 20h-2v2h2v-2zm-2-4v-2h-2v2h2zm2 7v2h2v-2h-2zm8-3v-2h-2v2h2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#373737"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 53v-4h-2v2h-2v6h2v-2h4v-2h-2zm-4 6v5h2v-3h2v3h2v-5h-6zm4-26v-2h2v-4h-6v3h-2v2h2v1h4zM19 56v2h-2v4h6v-6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 28h-2v-3h-4v5h6v-2zm-6 22v4h6v-4h-6zm12-34v-2h-2v2h2zm0 9h2v-1h-2v1zm-10-3v-2h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 23v2h2v-2h2v-3h-2v-2h-4v2h2v2h-6v1h6zm-8-1h-2v1h2v-1zm20 29v-2h-2v4h-2v2h4v2h2v-6h-2zm-4 8v5h2v-3h2v3h2v-5h-6zm6-29v-3h-6v4h2v2h4v-1h2v-2h-2zm6 28v-2h-4v6h6v-4h-2zm0-24v-2h-2v2h-2v2h-2v-1h-6v1h-2v-1h-6v1h-2v-2h-2v-2h-2v2h-2v2h2v2h2v2h4v-1h6v1h2v-1h6v1h4v-2h2v-2h2v-2h-2zm0 10v-2h-2v2h-4v-1h-6v1h-2v-1h-6v1h-4v-2h-2v2h-2v2h6v2h2v-1h2v-2h4v3h2v-3h4v2h2v1h2v-2h6v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 50v4h6v-4h-6zm2-25v3h-2v2h6v-5h-4zm-6-9v-2h-2v2h2zm-2 9v-1h-2v1h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 24v-4h-2v4h2zm14-4h-2v2h2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 22v1h2v-1h-2zm-8 0v-2h2v-2h-4v2h-2v3h2v2h2v-2h6v-1h-6z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32,7v3h1V9h1V8h1V7H32z",
    fill: "#006c73"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#009496"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,6V5h-1V4h-1v3h3V6H34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,7v1h1v1h1v1h1V7H29z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31,4v1h-1v1h-1v1h3V4H31z",
    fill: "#00e0c8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#323232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 8v2h2V8h-2zm-8-4v2h2V4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,2h-2v2h2V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,0h-6v2h6V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 2v2h2V2h-2zm14 4v2h2V6h-2zm12 6h-2v2h2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 10h-2v2h2v-2zm4 39h-2v2h2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 51h-2v2h2v-2zm0-28v-5h-2v5h2zm-2 10v2h2v4h2v-6h-4zm0 24v2h2v2h2v-4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 53v2h2v-2h-2zm0-6v2h2v-2h-2zm-2-6v2h2v2h2v-4h-4zm0-16v2h2v2h2v-4h-4zM17 8v2h2V8h-2zm8-4v2h2V4h-2zm-4 2v2h2V6h-2zm-10 6v2h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10v2h2v-2h-2zM9 49v2h2v-2H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 51v2h2v-2H7zm-2 6v4h2v-2h2v-2H5zm4-34v-5H7v5h2zm-2 6v-2h2v-2H5v4h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 49v-2H5v2h2zm-2 4v2h2v-2H5zm2-8v-2h2v-2H5v4h2zm0-6v-4h2v-2H5v6h2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2ClosedImg);
export default __webpack_public_path__ + "static/media/h2_closed_img.50db3412d7d43fcf8c6de9a9b8d8c594.svg";
export { ForwardRef as ReactComponent };